import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { CompanyFile } from "@/types";

/**
 * This hook is used to remove a company file in the company files query
 * without refetching the entire query.
 */
export const useRemoveCompanyFile = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({ companyFileId }: { companyFileId: number }) => {
    queryClient.setQueryData(
      ["files", currentCompanyId],
      (cachedData: CompanyFile[]) => {
        return cachedData.filter(
          (cachedCompanyFile: CompanyFile) =>
            cachedCompanyFile.id !== companyFileId,
        );
      },
    );
  };
};
